import { Entity, PrimaryKey, Property, ManyToOne, OneToMany, Collection } from '@mikro-orm/core';
import { User } from '../../user/entities/user.entity';
import { Tag } from './tag.entity';
import { Chapter } from '../../chapter/entities/chapter.entity';

@Entity()
export class Newsfeed {
  @PrimaryKey({ autoincrement: true })
  id!: number;

  @ManyToOne(() => User)
  user!: User;

  @ManyToOne(() => Chapter, { nullable: true })
  chapter?: Chapter;

  @Property()
  title!: string;

  @Property()
  subject!: string;

  @Property({ nullable: true })
  description?: string;

  @Property({ nullable: true })
  audio?: string;

  @Property()
  is_live_edit!: boolean;

  @Property()
  is_public!: boolean;

  @OneToMany('Tag', 'newsfeed')
  tags = new Collection<Tag>(this);

  @Property()
  created_at: Date = new Date();

  @Property({ onUpdate: () => new Date() })
  updated_at: Date = new Date();

  @Property({ nullable: true })
  deleted_at?: Date;
}
